import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'RiskReassessmentCsvErrorDialog',
  props: {
    value: { type: Boolean },
    messages: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  messages: string[];
};

const $t = i18n.t.bind(i18n);





const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const close = () => {
  model.value = false;
};

return { __sfc: true,$t, props, emit, model, close, BaseFormCard, sharedMessages }
}

})